import { useTranslation } from 'react-i18next';
import { Button } from '@/shared/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';
import { PlusIcon } from 'lucide-react';
import { Toolbar } from '@/shared/components/custom/toolbar';
import { MembersFilters } from './MembersFilters';

interface MembersToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  activeFiltersCount: number;
  onResetFilters: () => void;
  onInviteClick: () => void;
}

export function MembersToolbar({
  search,
  onSearchChange,
  activeFiltersCount,
  onResetFilters,
  onInviteClick,
}: MembersToolbarProps) {
  const { t } = useTranslation('members');

  return (
    <Toolbar className="pt-0">
      <Toolbar.Info title={t('page.title')} description={t('page.subtitle')} />
      <Toolbar.Actions>
        <MembersFilters
          search={search}
          onSearchChange={onSearchChange}
          activeFiltersCount={activeFiltersCount}
          onReset={onResetFilters}
        />
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              size="icon"
              variant="default"
              data-testid="members-invite-button"
              onClick={onInviteClick}
              aria-label={t('toolbar.invite')}
            >
              <PlusIcon className="h-4 w-4" />
            </Button>
          </TooltipTrigger>
          <TooltipContent>{t('toolbar.invite')}</TooltipContent>
        </Tooltip>
      </Toolbar.Actions>
    </Toolbar>
  );
}
